export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/options.worker.777b69d4.worker.js");
}
